import { Playground } from "./Playground";

export function PlaygroundPage() {
  return <Playground />;
}
